import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import UploadPostListLayer from "../../components/Post/UploadPostListLayer";


const UploadPostList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Upload Post" />

        {/* UsersListLayer */}
        <UploadPostListLayer />

      </MasterLayout>

    </>
  );
};

export default UploadPostList;
